import { Injectable } from '@angular/core';
import { VueForgotCredentialsService } from '@vue/vueframework';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ForgotCredentialsService extends VueForgotCredentialsService {
  public constructor(private router: Router) {
    super();
  }

  public forgotPassword(): void {
    this.router.navigate([ 'passwordReset' ]);
  }

  public forgotUserName(): void {
    this.router.navigate([ 'usernamelookup' ]);
  }
}
